var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoresult = function SvgNoresult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 112
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__a",
    x1: "50.005%",
    x2: "50.005%",
    y1: "99.986%",
    y2: "-.018%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__b",
    x1: "50.038%",
    x2: "50.038%",
    y1: "100.004%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__c",
    x1: "50.005%",
    x2: "50.005%",
    y1: "100.004%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__e",
    x1: "50.017%",
    x2: "50.017%",
    y1: "100%",
    y2: ".014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__f",
    x1: "50.056%",
    x2: "50.056%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__g",
    x1: "50.007%",
    x2: "50.007%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__h",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__i",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__j",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__k",
    x1: "50%",
    x2: "50%",
    y1: "100.002%",
    y2: ".002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__l",
    x1: "50%",
    x2: "50%",
    y1: "100.006%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__m",
    x1: "50.004%",
    x2: "50.004%",
    y1: "99.968%",
    y2: "-.006%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__n",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__o",
    x1: "50.03%",
    x2: "50.03%",
    y1: "100.032%",
    y2: ".04%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__p",
    x1: "50.09%",
    x2: "50.09%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__q",
    x1: "50.004%",
    x2: "50.004%",
    y1: "100.007%",
    y2: ".003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__r",
    x1: "49.99%",
    x2: "49.99%",
    y1: "100.052%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noresult_svg__s",
    x1: "49.995%",
    x2: "49.995%",
    y1: "99.921%",
    y2: "-.01%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9800",
    strokeDasharray: 12,
    strokeWidth: 4,
    d: "M49.352 95.829c22.892 0 41.45-18.701 41.45-41.77 0-23.07-18.558-41.771-41.45-41.771-22.892 0-41.45 18.701-41.45 41.77 0 23.07 18.558 41.77 41.45 41.77zm109.317-8.262c22.892 0 41.449-18.702 41.449-41.77 0-23.07-18.557-41.771-41.45-41.771-22.891 0-41.449 18.7-41.449 41.77 0 23.07 18.558 41.77 41.45 41.77z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.796 25.905a10.379 10.379 0 0 1-2.783-7.067 10.508 10.508 0 0 1 5.106-8.967 6.13 6.13 0 0 1-1.066-3.442c0-3.464 2.884-6.271 6.441-6.271 2.82-.029 5.329 1.804 6.179 4.515A9.647 9.647 0 0 1 26.89.158c5.3 0 9.597 4.184 9.597 9.344a9.124 9.124 0 0 1-.588 3.224c.194-.014.39-.03.588-.03 4.254 0 7.702 3.358 7.702 7.5 0 .254-.013.506-.039.758 3.403 1.428 5.785 4.721 5.785 8.556 0 5.143-4.282 9.314-9.565 9.314a9.884 9.884 0 0 1-1.656-.143c.027.31.046.625.046.941 0 5.772-4.806 10.452-10.734 10.452a10.875 10.875 0 0 1-6.113-1.861 8.106 8.106 0 0 1-5.19 1.861c-4.43 0-8.019-3.495-8.019-7.803 0-.186.016-.37.03-.553h-.03c-4.741 0-8.586-3.744-8.586-8.361a8.336 8.336 0 0 1 4.678-7.452z",
    fill: "url(#noresult_svg__a)",
    fillRule: "nonzero",
    transform: "translate(169.896 36.033)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    fillRule: "nonzero",
    d: "M175.56 61.903a9.936 9.936 0 0 1-2.662-6.764 10.055 10.055 0 0 1 4.888-8.583 5.855 5.855 0 0 1-1.02-3.303c0-3.314 2.76-6.002 6.164-6.002 2.701-.027 5.103 1.726 5.922 4.32a9.23 9.23 0 0 1 7.85-4.317c5.074 0 9.185 4.005 9.185 8.95a8.72 8.72 0 0 1-.563 3.087c.187-.013.374-.027.563-.027 4.072 0 7.372 3.213 7.372 7.179 0 .242-.014.484-.039.725 3.257 1.377 5.537 4.52 5.537 8.189 0 4.923-4.1 8.914-9.156 8.914a9.467 9.467 0 0 1-1.594-.135c.027.296.043.596.043.9 0 5.524-4.6 10.001-10.273 10.001a10.412 10.412 0 0 1-5.85-1.78 7.768 7.768 0 0 1-4.95 1.785c-4.238 0-7.675-3.346-7.675-7.473 0-.179.014-.353.028-.53h-.028c-4.539 0-8.219-3.583-8.219-8.003a7.981 7.981 0 0 1 4.477-7.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M192.974 51.44v55.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__b)",
    fillRule: "nonzero",
    d: "M191.42 51.44h3.004v55.594h-3.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M192.142 51.44h1.663v55.594h-1.663zm1 16.65-9.852-10.125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m182.698 58.551 1.187-1.173 9.851 10.127-1.186 1.173zM193.142 76.793l10.212-7.22M192.665 76.103l10.212-7.223.955 1.372-10.212 7.222z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76 26.421a11.014 11.014 0 0 0 2.586-8.709 10.967 10.967 0 0 0-4.828-7.678 6.512 6.512 0 0 0 1.029-3.527c0-3.54-2.783-6.408-6.217-6.408-2.789.02-5.225 1.904-5.967 4.613A9.206 9.206 0 0 0 22.43.099c-5.117 0-9.266 4.275-9.266 9.55a9.758 9.758 0 0 0 .567 3.295c-.187-.014-.376-.03-.567-.03-4.1 0-7.439 3.443-7.439 7.666 0 .262.014.519.04.773C2.347 22.897.157 26.325.177 30.098c0 5.258 4.135 9.52 9.235 9.52a9.07 9.07 0 0 0 1.594-.145c-.027.317-.043.638-.043.962 0 5.898 4.639 10.681 10.364 10.681a10.1 10.1 0 0 0 5.901-1.903 7.568 7.568 0 0 0 5.01 1.903c4.277 0 7.744-3.573 7.744-7.98 0-.19-.016-.379-.028-.567h.028c4.58 0 8.29-3.826 8.29-8.544a8.577 8.577 0 0 0-4.512-7.604z",
    fill: "url(#noresult_svg__c)",
    fillRule: "nonzero",
    transform: "translate(150.766 36.492)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00897B",
    fillRule: "nonzero",
    d: "M193.329 62.862a10.336 10.336 0 0 0 2.423-8.172 10.291 10.291 0 0 0-4.53-7.205 6.115 6.115 0 0 0 .966-3.312c0-3.323-2.612-6.015-5.837-6.015a5.863 5.863 0 0 0-5.591 4.329 8.642 8.642 0 0 0-7.447-4.331c-4.803 0-8.698 4.014-8.698 8.964 0 1.055.18 2.102.533 3.094a6.672 6.672 0 0 0-.533-.027c-3.856 0-6.98 3.213-6.98 7.195 0 .245.011.486.036.725-3.203 1.452-5.256 4.67-5.238 8.21 0 4.934 3.872 8.934 8.67 8.934a8.48 8.48 0 0 0 1.501-.135c-.025.298-.04.599-.04.902 0 5.538 4.354 10.025 9.726 10.025a9.49 9.49 0 0 0 5.539-1.786 7.11 7.11 0 0 0 4.703 1.786c4.013 0 7.267-3.353 7.267-7.492 0-.179-.014-.355-.025-.532h.025c4.297 0 7.782-3.592 7.782-8.021a8.043 8.043 0 0 0-4.252-7.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__d)",
    fillRule: "nonzero",
    d: "M175.724 51.419h2.259v56.638h-2.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M176.367 52.215h1.136v55.842h-1.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m176.26 68.66 9.327-10.15.834.777-9.328 10.152zM166.674 71.013l.677-.92 9.67 7.238-.678.919z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19 17.736a7.07 7.07 0 0 1-1.894-4.82 7.161 7.161 0 0 1 3.48-6.109 4.177 4.177 0 0 1-.727-2.352C4.05 2.095 6.015.18 8.438.18a4.372 4.372 0 0 1 4.21 3.076A6.585 6.585 0 0 1 18.25.18c3.612 0 6.54 2.85 6.54 6.367a6.19 6.19 0 0 1-.4 2.199c.132 0 .264-.021.4-.021 2.9 0 5.239 2.295 5.239 5.111 0 .173-.01.345-.027.516a6.347 6.347 0 0 1 3.942 5.832c0 3.505-2.918 6.346-6.518 6.346-.382 0-.763-.032-1.139-.096.02.21.032.424.032.64 0 3.934-3.275 7.115-7.315 7.115a7.416 7.416 0 0 1-4.147-1.246A5.528 5.528 0 0 1 11.32 34.2c-3.018 0-5.466-2.382-5.466-5.32 0-.128 0-.252.02-.376h-.02c-3.232 0-5.85-2.55-5.85-5.696a5.68 5.68 0 0 1 3.188-5.073z",
    fill: "url(#noresult_svg__e)",
    fillRule: "nonzero",
    transform: "translate(147.805 61.738)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    fillRule: "nonzero",
    d: "M151.586 79.451a6.767 6.767 0 0 1-1.822-4.608 6.852 6.852 0 0 1 3.332-5.848 3.992 3.992 0 0 1-.695-2.252c0-2.258 1.881-4.09 4.2-4.09a4.183 4.183 0 0 1 4.03 2.945 6.296 6.296 0 0 1 5.36-2.945c3.457 0 6.26 2.73 6.26 6.096a5.928 5.928 0 0 1-.382 2.105c.127 0 .253-.019.382-.019 2.774 0 5.024 2.19 5.024 4.891 0 .165-.008.33-.025.494a6.075 6.075 0 0 1 3.774 5.581c0 3.356-2.794 6.075-6.24 6.075a6.41 6.41 0 0 1-1.08-.091c.019.202.03.406.03.612 0 3.764-3.134 6.817-7 6.817A7.107 7.107 0 0 1 162.748 94a5.293 5.293 0 0 1-3.385 1.214c-2.887 0-5.238-2.28-5.238-5.093 0-.122 0-.241.018-.36h-.018c-3.092 0-5.6-2.442-5.6-5.453a5.44 5.44 0 0 1 3.06-4.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M163.454 72.32v37.885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__f)",
    fillRule: "nonzero",
    d: "M162.395 72.32h2.047v37.885h-2.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M162.887 72.32h1.132v37.885h-1.132zm.68 11.347-6.711-6.901"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m156.45 77.165.809-.8 6.71 6.901-.807.8zM163.567 89.598l6.96-4.921M163.244 89.125l6.959-4.92.65.932-6.959 4.921z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.283 17.713a7.38 7.38 0 0 0-1.505-10.998 4.386 4.386 0 0 0 .683-2.368c.05-2.12-1.477-3.945-3.56-4.252a4.162 4.162 0 0 0-4.618 3.047 6.18 6.18 0 0 0-5.32-3.096c-3.435 0-6.22 2.869-6.22 6.41 0 .754.128 1.503.38 2.213-.125 0-.252-.021-.38-.021a5.034 5.034 0 0 0-3.554 1.53 5.113 5.113 0 0 0-1.438 3.615c0 .175 0 .35.025.52a6.393 6.393 0 0 0-3.749 5.869c0 3.527 2.777 6.39 6.2 6.39.36 0 .718-.033 1.072-.097-.018.214-.03.427-.03.645 0 3.959 3.116 7.17 6.956 7.17 1.42 0 2.804-.446 3.96-1.276a5.087 5.087 0 0 0 3.364 1.276 5.243 5.243 0 0 0 3.7-1.594 5.319 5.319 0 0 0 1.497-3.763c0-.128 0-.255-.018-.38h.018c3.075 0 5.566-2.57 5.566-5.739a5.754 5.754 0 0 0-3.029-5.102z",
    fill: "url(#noresult_svg__g)",
    fillRule: "nonzero",
    transform: "translate(140.973 62.885)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00897B",
    fillRule: "nonzero",
    d: "M169.452 80.567a6.938 6.938 0 0 0-1.414-10.328c.425-.662.65-1.434.65-2.222.047-1.99-1.387-3.704-3.342-3.992a3.909 3.909 0 0 0-4.336 2.86 5.804 5.804 0 0 0-4.999-2.905c-3.225 0-5.837 2.694-5.837 6.018 0 .708.12 1.41.357 2.077-.118 0-.227-.019-.357-.019-2.613.03-4.709 2.187-4.685 4.82 0 .165 0 .328.023.487a6.006 6.006 0 0 0-3.519 5.508c0 3.312 2.606 5.997 5.82 5.997a5.57 5.57 0 0 0 1.006-.092c-.018.2-.027.402-.027.606 0 3.716 2.924 6.73 6.529 6.73a6.374 6.374 0 0 0 3.719-1.199 4.76 4.76 0 0 0 3.156 1.198c2.724-.031 4.908-2.281 4.879-5.026 0-.12 0-.23-.018-.356h.018a5.269 5.269 0 0 0 3.719-1.601 5.344 5.344 0 0 0 1.505-3.783 5.4 5.4 0 0 0-2.847-4.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__h)",
    fillRule: "nonzero",
    d: "M157.637 72.885h1.517v38.016h-1.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M158.067 73.42h1v37.481h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m157.993 84.455 6.261-6.813.56.522-6.261 6.813zM151.56 86.037l.454-.618 6.491 4.858-.455.617z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__i)",
    fillRule: "nonzero",
    d: "M92.523 54.24h64.224v57.607H92.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M50.39 54.24h104.762v55.77H50.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__j)",
    fillRule: "nonzero",
    d: "M160.165 59.748H57.225V32.666h99.182c2.076 0 3.758 1.695 3.758 3.787v23.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M57.223 33.738h98.298c2.076 0 3.758 1.695 3.758 3.787V59.05H57.223V33.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M57.223 33.738h98.298c2.076 0 3.758 1.695 3.758 3.787V59.05H57.223V33.738z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__k)",
    fillRule: "nonzero",
    d: "M56.995 3.287 21.467 28.5v83.344h71.056V28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M90.929 28.076 57.223 3.287 23.517 28.076v20.883h67.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M90.929 28.076 57.223 3.287 23.517 28.076v20.883h67.412z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M23.517 48.961h67.412v61.049H23.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__l)",
    fillRule: "nonzero",
    d: "M95.256 40.467 57.223 13.098 18.734 40.467l-2.505-9.626L57.223.773l40.994 30.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "m94.907 39.058-37.684-27.64-37.683 27.64-1.61-8.655L57.223 1.586l39.295 28.817z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m94.907 39.058-37.684-27.64-37.683 27.64-1.61-8.655L57.223 1.586l39.295 28.817z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M38.092 62.272h38.261v47.738H38.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M38.092 62.272h38.261v8.262H38.092zm0 39.476h38.261v8.262H38.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0",
    fillRule: "nonzero",
    d: "M121.296 92.845a.343.343 0 0 0 .342-.344.343.343 0 0 0-.342-.344.343.343 0 0 0-.342.344c0 .19.153.344.342.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M111.881 75.125h18.675v34.885h-18.675zm23.458-7.344h17.536v12.852h-17.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M135.339 67.781h17.536v5.738h-17.536z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.892 14.71a5.9 5.9 0 0 1-1.594-4.015A5.977 5.977 0 0 1 4.2 5.602a3.466 3.466 0 0 1-.606-1.96c.035-2 1.672-3.595 3.657-3.562a3.648 3.648 0 0 1 3.517 2.569A5.477 5.477 0 0 1 15.436.085c3.011 0 5.453 2.378 5.453 5.308a5.19 5.19 0 0 1-.335 1.837c.111 0 .228-.017.335-.017 2.416 0 4.375 1.908 4.375 4.26 0 .143-.008.287-.023.43a5.288 5.288 0 0 1 3.286 4.86c0 2.922-2.432 5.29-5.434 5.29-.315 0-.63-.027-.94-.08.016.177.025.354.025.535 0 3.28-2.733 5.937-6.097 5.937a6.175 6.175 0 0 1-3.473-1.058 4.61 4.61 0 0 1-2.95 1.058c-2.505 0-4.554-1.985-4.554-4.436 0-.106 0-.211.016-.315h-.016c-2.694 0-4.879-2.127-4.879-4.748a4.737 4.737 0 0 1 2.667-4.237z",
    fill: "url(#noresult_svg__m)",
    fillRule: "nonzero",
    transform: "translate(11.16 71.607)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    fillRule: "nonzero",
    d: "M14.537 86.297a5.644 5.644 0 0 1-1.512-3.842 5.709 5.709 0 0 1 2.776-4.874 3.333 3.333 0 0 1-.579-1.878 3.487 3.487 0 0 1 1.05-2.436c.658-.64 1.54-.99 2.453-.974a3.49 3.49 0 0 1 3.36 2.453 5.243 5.243 0 0 1 4.468-2.453c2.88 0 5.217 2.274 5.217 5.081 0 .6-.107 1.194-.319 1.754.105 0 .212-.017.32-.017 2.313 0 4.187 1.837 4.187 4.079 0 .137-.006.274-.02.41a5.069 5.069 0 0 1 3.143 4.655c0 2.798-2.328 5.065-5.202 5.065-.305 0-.61-.026-.91-.078.015.168.024.34.024.512 0 3.137-2.612 5.683-5.837 5.683a5.908 5.908 0 0 1-3.311-1.015 4.406 4.406 0 0 1-2.822 1.012c-2.407 0-4.359-1.9-4.359-4.245 0-.101 0-.202.016-.301h-.016c-2.578 0-4.669-2.036-4.669-4.547a4.536 4.536 0 0 1 2.542-4.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M24.43 80.353v31.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__n)",
    fillRule: "nonzero",
    d: "M23.546 80.353h1.708v31.583h-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M23.956 80.353h1v31.583h-1zm.57 9.458-5.598-5.754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m18.59 84.39.674-.665 5.596 5.753-.673.665zM24.526 94.755l5.8-4.102M24.255 94.362l5.8-4.102.542.778-5.801 4.103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.892 14.71a5.9 5.9 0 0 1-1.594-4.015A5.977 5.977 0 0 1 4.2 5.602a3.466 3.466 0 0 1-.606-1.96c.035-2 1.672-3.595 3.657-3.562a3.648 3.648 0 0 1 3.517 2.569A5.477 5.477 0 0 1 15.436.085c3.011 0 5.453 2.378 5.453 5.308a5.19 5.19 0 0 1-.335 1.837c.111 0 .228-.017.335-.017 2.416 0 4.375 1.908 4.375 4.26 0 .143-.008.287-.023.43a5.288 5.288 0 0 1 3.286 4.86c0 2.922-2.432 5.29-5.434 5.29-.315 0-.63-.027-.94-.08.016.177.025.354.025.535 0 3.28-2.733 5.937-6.097 5.937a6.175 6.175 0 0 1-3.473-1.058 4.61 4.61 0 0 1-2.95 1.058c-2.505 0-4.554-1.985-4.554-4.436 0-.106 0-.211.016-.315h-.016c-2.694 0-4.879-2.127-4.879-4.748a4.737 4.737 0 0 1 2.667-4.237z",
    fill: "url(#noresult_svg__m)",
    fillRule: "nonzero",
    transform: "translate(0 71.607)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    fillRule: "nonzero",
    d: "M3.377 86.297a5.644 5.644 0 0 1-1.512-3.842 5.713 5.713 0 0 1 2.776-4.874 3.332 3.332 0 0 1-.578-1.878 3.483 3.483 0 0 1 1.05-2.436 3.43 3.43 0 0 1 2.453-.974 3.489 3.489 0 0 1 3.359 2.453 5.244 5.244 0 0 1 4.468-2.453c2.881 0 5.218 2.274 5.218 5.081 0 .6-.108 1.194-.32 1.754.106 0 .213-.017.32-.017 2.314 0 4.188 1.837 4.188 4.079 0 .137-.007.274-.02.41a5.066 5.066 0 0 1 3.142 4.655c0 2.798-2.327 5.065-5.201 5.065-.306 0-.61-.026-.911-.078.016.168.025.34.025.512 0 3.137-2.612 5.683-5.837 5.683a5.914 5.914 0 0 1-3.312-1.015 4.403 4.403 0 0 1-2.821 1.012c-2.408 0-4.36-1.9-4.36-4.245 0-.101 0-.202.016-.301h-.015c-2.578 0-4.67-2.036-4.67-4.547a4.538 4.538 0 0 1 2.542-4.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M13.271 80.353v31.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__n)",
    fillRule: "nonzero",
    d: "M12.387 80.353h1.708v31.583h-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M12.797 80.353h1v31.583h-1zm.569 9.458-5.598-5.754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m7.434 84.391.673-.666 5.596 5.753-.674.665zM13.366 94.755l5.801-4.102M13.096 94.364l5.8-4.102.542.778-5.801 4.103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.407 14.96a6.164 6.164 0 0 0 1.453-4.88 6.135 6.135 0 0 0-2.708-4.301 3.642 3.642 0 0 0 .577-1.974A3.49 3.49 0 0 0 20.761.258 3.47 3.47 0 0 0 16.91 2.8 5.153 5.153 0 0 0 12.47.218a5.213 5.213 0 0 0-3.69 1.587 5.302 5.302 0 0 0-1.493 3.756c0 .626.107 1.247.316 1.836-.105 0-.21-.016-.316-.016a4.194 4.194 0 0 0-2.973 1.282 4.26 4.26 0 0 0-1.193 3.028c0 .147 0 .292.02.434a5.336 5.336 0 0 0-3.124 4.893c-.027 2.907 2.283 5.288 5.167 5.327.3 0 .6-.027.895-.08a6.314 6.314 0 0 0-.025.537c0 3.3 2.597 5.967 5.799 5.967a5.662 5.662 0 0 0 3.302-1.065 4.238 4.238 0 0 0 2.804 1.065c2.417-.03 4.353-2.028 4.327-4.464 0-.108 0-.211-.016-.317h.016c2.59-.03 4.667-2.17 4.639-4.78a4.8 4.8 0 0 0-2.517-4.249z",
    fill: "url(#noresult_svg__o)",
    fillRule: "nonzero",
    transform: "translate(3.872 71.607)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00897B",
    fillRule: "nonzero",
    d: "M27.61 86.538a5.785 5.785 0 0 0 1.357-4.574 5.762 5.762 0 0 0-2.537-4.032c.353-.552.54-1.195.54-1.852a3.277 3.277 0 0 0-2.785-3.335 3.257 3.257 0 0 0-3.615 2.391 4.837 4.837 0 0 0-4.168-2.423c-2.714.038-4.886 2.282-4.855 5.017 0 .59.1 1.175.298 1.73-.098 0-.198-.016-.298-.016-2.182.025-3.93 1.827-3.906 4.026 0 .138 0 .273.02.406a5.005 5.005 0 0 0-2.933 4.59c-.03 2.73 2.142 4.967 4.85 4.999.283 0 .564-.026.841-.076a6.516 6.516 0 0 0-.023.505c0 3.098 2.437 5.61 5.444 5.61a5.32 5.32 0 0 0 3.1-1c.727.643 1.66.996 2.627.997a4.095 4.095 0 0 0 2.895-1.246 4.164 4.164 0 0 0 1.173-2.945c0-.1 0-.2-.014-.298h.014a4.392 4.392 0 0 0 3.1-1.336 4.456 4.456 0 0 0 1.254-3.153 4.503 4.503 0 0 0-2.38-3.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__p)",
    fillRule: "nonzero",
    d: "M17.757 80.135h1.264v31.693h-1.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "M18.117 80.58h1v31.248h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    fillRule: "nonzero",
    d: "m18.062 89.782 5.22-5.68.466.434-5.22 5.68zM12.691 91.098l.38-.514 5.412 4.05-.38.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__q)",
    fillRule: "nonzero",
    d: "M162.684 12.343a34.72 34.72 0 0 0-24.859-10.78 34.714 34.714 0 0 0-25.017 10.401c-13.189 13.399-13.412 35.214-.512 48.886 11.699 12.417 30.58 14.52 44.687 4.978l25.189 26.393c.311.327.74.516 1.189.526a1.69 1.69 0 0 0 1.209-.478l6.274-6.08a1.714 1.714 0 0 0 .048-2.416l-25.188-26.394c9.97-13.762 8.696-32.75-3.02-45.036zm-7.846 42.44c-9.92 9.617-25.696 9.308-35.238-.688-9.542-9.996-9.236-25.895.683-35.511 9.92-9.617 25.696-9.308 35.238.688a25.22 25.22 0 0 1 6.957 17.898 25.206 25.206 0 0 1-7.64 17.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__r)",
    fillRule: "nonzero",
    d: "M119.107 29.696c-2.803 0-2.808 4.388 0 4.388 2.809 0 2.806-4.388 0-4.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#noresult_svg__s)",
    fillRule: "nonzero",
    d: "M138.643 15.636c-7.543-.172-14.409 3.643-18.057 9.41-1.192 1.878 2.19 3.537 3.375 1.669 3.022-4.767 8.766-7.804 14.972-7.636 6.508.165 12.432 3.918 15.568 9.125 1.191 1.976 4.307.18 3.125-1.785-3.806-6.328-11.19-10.606-18.983-10.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M165.417 11.007A34.728 34.728 0 0 0 140.558.227a34.714 34.714 0 0 0-25.017 10.402c-13.189 13.398-13.412 35.213-.512 48.885 11.699 12.417 30.58 14.52 44.687 4.978l25.189 26.393a1.685 1.685 0 0 0 2.398.048l6.277-6.082a1.715 1.715 0 0 0 .047-2.416L168.44 56.04c9.968-13.762 8.693-32.75-3.022-45.034zm-7.846 42.44c-9.92 9.617-25.696 9.308-35.238-.688-9.542-9.996-9.236-25.895.683-35.511 9.92-9.616 25.696-9.308 35.238.688a25.22 25.22 0 0 1 6.957 17.899 25.204 25.204 0 0 1-7.64 17.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M121.84 28.353c-2.803 0-2.808 4.389 0 4.389s2.806-4.389 0-4.389zM141.376 14.3c-7.543-.171-14.41 3.643-18.058 9.41-1.19 1.878 2.191 3.537 3.376 1.669 3.022-4.767 8.765-7.803 14.971-7.636 6.51.166 12.433 3.918 15.569 9.126 1.191 1.976 4.307.179 3.125-1.786-3.806-6.323-11.19-10.603-18.983-10.782z"
  }))));
};
export default SvgNoresult;